export const invoicesMisc = {
  sendLink: {
    title: "Wyślij link do faktury",
    already: {
      title: "Do tej rezerwacji wystawiono już fakturę.",
      onlyOne: "Dozwolona jest tylko <b>1 faktura na rezerwację</b>.",
      offerPdf:
        "Jeśli Państwo chcą, możemy od razu wysłać PDF faktury przez WhatsApp.",
    },
    openPdf: "Otwórz PDF",
    sendWhatsapp: "Wyślij fakturę przez WhatsApp",
    sending: "Wysyłanie...",
    info: {
      title: "Link do faktury zostanie wysłany do gościa przez WhatsApp.",
      desc: "Gość uzupełni swoje dane podatkowe z poziomu linku i będzie mógł pobrać fakturę elektroniczną.",
    },
    rule: "<strong>Zasada:</strong> można wystawić tylko <b>1 fakturę na rezerwację</b>.",
    accept: "Akceptuj i wyślij",
    toast: {
      invoiceSent: "Faktura wysłana przez WhatsApp.",
      linkSent: "Link do faktury wysłany przez WhatsApp.",
    },
    warn: {
      noReservation: "Nie znaleziono jeszcze ID rezerwacji.",
    },
    err: {
      sendInvoiceFailed: "Nie udało się wysłać faktury przez WhatsApp.",
      sendLinkFailed: "Nie udało się wysłać linku.",
    },
  },
  country: {
    placeholder: "Wybierz kraj (opcjonalnie)",
    noResult: "Brak wyników",
  },
  adjust: {
    title: "Dostosuj: {name}",
    type: {
      apartment: "Apartament(y)",
      hotel: "Hotel (pokoje)",
      villa: "Wille",
      camping: "Miejsca kempingowe",
      default: "Obiekty",
    },
    usage: "Obecne wykorzystanie",
    available: "Dostępne",
    unitDefault: "jednostek",
    hintReduce:
      "Zmniejszenie obowiązuje od razu i <b>nie</b> powoduje zwrotu środków. Na kolejnej fakturze zapłacą Państwo mniej.",
    unitPriceCurrent: "Obecna cena jednostkowa",
    totalBeforeProration: "Łącznie (przed rozliczeniem proporcjonalnym)",
    prorationNote:
      "Zostanie zastosowane <b>rozliczenie proporcjonalne</b> za dni, które upłynęły w cyklu.",
    confirmIncrease: "Potwierdź zwiększenie",
    confirmDecrease: "Potwierdź zmniejszenie",
    err: {
      selectAmount: "Wybierz liczbę do zmiany.",
      failed: "Nie udało się wykonać operacji.",
    },
    toast: {
      added: "Dodano jednostki",
      reduced: "Zmniejszono liczbę jednostek",
      addedDetail: "Zostanie zastosowane rozliczenie proporcjonalne za pozostałe dni cyklu.",
      reducedDetail: "Na kolejnej fakturze zapłacą Państwo mniej (bez zwrotu środków).",
    },
  },
  menu: {
    title: "Moja subskrypcja",
    subtitle: "Zarządzaj subskrypcjami, fakturami i metodami płatności",
    subscription: "Moja subskrypcja",
    paymentMethod: "Metoda płatności",
    invoices: "Faktury",
  },
  custom: {
    title: "Plan indywidualny",
    whatDoYouNeed: "Czego Państwo potrzebują?",
    salesContact:
      "Nasz zespół sprzedaży skontaktuje się z Państwem najszybciej, jak to możliwe.",
    tellUs: "Prosimy opowiedzieć nam więcej o swoim projekcie",
    sentOk: "Wysłano pomyślnie",
    salesContactShort:
      "Zespół sprzedaży skontaktuje się najszybciej, jak to możliwe",
    contactSales: "Skontaktuj się ze sprzedażą",
    err: {
      required:
        "Prosimy określić, czego Państwo potrzebują, abyśmy mogli się skontaktować",
      failed: "Niestety nie udało się przetworzyć zgłoszenia",
    },
  },
  common: {
    cancel: "Anuluj",
    close: "Zamknij",
  },
};
